export default function Header() {
  return (
    <header>
      <div className="container">
        <a href="/">Andreas Goßen</a>
      </div>
    </header>
  );
}
